import store from "../../../store";
import { ReceptionSearchActiveKinds, ReceptionStatusSearchCondition } from ".";
import { InOutKinds, InOutKindsName, ReceptionDateKinds, ReceptionDateKindsName, } from "../kinds";

import { Patient } from "../../patient";
import { DateDuration } from "../../system";
import { FormatReference } from "../../format";
import { User } from "../../user";
import { Department } from "../../department";
import { ReceptionDeliveryKind } from "../items";
import { ReceptionDateTranslator } from "../ReceptionDateTranslator";
import { IConfiguration } from "../../../domain/configuration";

// 依頼受付検索条件
export class ReceptionSearchCondition {
  dateKind: ReceptionDateKinds;
  duration: DateDuration;
  patient: Patient;
  formats: FormatReference[];
  paperName: string;
  managers: User[];
  creators: User[];
  isDepartmentGroupSpecified: boolean;
  departments: Department[];
  receptionNumber: string;
  deliveryType: ReceptionDeliveryKind;
  generalFlag1Status: ReceptionSearchActiveKinds;
  statuses: ReceptionStatusSearchCondition;
  inOutType: InOutKinds;

  isParamPatientSearch: boolean; // 患者指定でWF起動されたときにtrueになる（初回のみ）

  private _dateTranslator: ReceptionDateTranslator;


  constructor() {
    this.duration = new DateDuration(null, null);
    this.formats = [];
    this.managers = [];
    this.creators = [];
    this.isDepartmentGroupSpecified = false;
    this.departments = [];
    this.generalFlag1Status = ReceptionSearchActiveKinds.NotSpecificated;
    this.statuses = new ReceptionStatusSearchCondition();
    this.inOutType = InOutKinds.None;
    this._dateTranslator = new ReceptionDateTranslator();
    this.deliveryType = new ReceptionDeliveryKind();
  }

  needConfirm(): boolean {
    if (this.duration.from && this.duration.to && this.duration.years <= 5) {
      // 期間指定があり、期間が5年以内
      return false;
    }
    if (!this.statuses.isFinished) {
      // 終了ステータスが選択されていない
      return false;
    }
    if (this.patient) {
      // 患者が選択されている
      return false;
    }
    if (this.formats.length > 0) {
      // フォーマットが選択されている
      return false;
    }
    if (this.managers.length > 0) {
      // 対応責任者が選択されている
      return false;
    }
    if (this.creators.length > 0) {
      // 依頼作成者が選択されている
      return false;
    }
    if (this.departments.length > 0) {
      // 診療科が選択されている
      return false;
    }
    if (this.receptionNumber) {
      // 受付番号が入力されている
      return false;
    }
    // あまり絞り込めない条件なので対象外
    // if (this.generalFlag1) {
    //   // 公開フラグが立っているもののみ
    //   return false;
    // }

    return true;
  }

  getSummary(generalFlag1Name: string): string {
    const config = store.getters.configuration as IConfiguration;
    const summary = this.toDurationString(this.dateKind, this.duration) + 
      (this.patient ? this.toItemString("患者番号", this.patient.id) : "") +
      (this.formats.length > 0 ? this.toItemString(config.wording.format.attributes.name + "名", "指定あり") : "") +
      (this.paperName ? this.toItemString("手書き" + config.wording.format.attributes.name + "名", this.paperName) : "") +
      (this.managers.length > 0 ? this.toItemString("対応責任者", "指定あり") : "") +
      (this.isDepartmentGroupSpecified ? this.toItemString(config.wording.common.departmentGroup, "指定あり") : "") +
      (this.departments.length > 0 ? this.toItemString(config.wording.common.department, "指定あり") : "") +
      (this.receptionNumber ? this.toItemString("受付番号", this.receptionNumber) : "") +
      this.toItemString("ステータス", this.statuses.getSummary());
  
    const subSummary =
      (this.creators.length > 0 ? this.toItemString("依頼作成者", "指定あり") : "") +
      (this.deliveryType.code !== 0 ? this.toItemString("交付方法", this.deliveryType.name) : "") +
      (this.generalFlag1Status !== ReceptionSearchActiveKinds.NotSpecificated
        ? generalFlag1Name + (this.generalFlag1Status === ReceptionSearchActiveKinds.Activated ? " " : "なし ")
        : "") +
      (this.inOutType !== InOutKinds.None ? this.toItemString("入院/外来", InOutKindsName.getDisplayName(this.inOutType)) : "");
  
    if (summary.length === 0) {
      // 主要な検索条件が指定されていなければ補助的な条件を表示
      return subSummary.length > 0 ? subSummary : "";
    } else {
      return subSummary.length > 0 ? (summary + " 他") : summary;
    }
  }

  private toDurationString(kind: ReceptionDateKinds, value: DateDuration): string {
    if (value && (value.from || value.to)) {
      return ReceptionDateKindsName.getDisplayName(kind) + "：" + this._dateTranslator.toDateDispString(value.from) + "～" + this._dateTranslator.toDateDispString(value.to) + " ";
    } 
    return "";
  }

  private toItemString(itemLabel: string, value: string): string {
    if (value.length === 0) { return ""; }
    return itemLabel + "：" + value + " ";
  }

  clone(): ReceptionSearchCondition {
    const newObj = new ReceptionSearchCondition();
    newObj.dateKind = this.dateKind;
    newObj.duration = this.duration;
    newObj.patient = this.patient;
    newObj.formats = this.formats;
    newObj.paperName = this.paperName;
    newObj.managers = this.managers;
    newObj.creators = this.creators;
    newObj.isDepartmentGroupSpecified = this.isDepartmentGroupSpecified;
    newObj.departments = this.departments;
    newObj.receptionNumber = this.receptionNumber;
    newObj.deliveryType = this.deliveryType;
    newObj.generalFlag1Status = this.generalFlag1Status;
    newObj.inOutType = this.inOutType;
    newObj.statuses = this.statuses.clone();

    newObj.isParamPatientSearch = this.isParamPatientSearch;

    return newObj;
  }
}
